import fetcher from 'api/fetcher';

import {
    resetSelectedVideo,
    setSelectedVideoUploadId,
    setVideoGallery,
    VideoGalleryItem,
} from 'store/models/videoGallery';
import { AppThunkAction } from 'store/utils';

type FetchLoadVideoGallery = () => AppThunkAction<void>;

export const fetchLoadVideoGallery: FetchLoadVideoGallery = () => {
    return (dispatch, getState) => {
        void fetcher
            .get<unknown, VideoGalleryItem[]>('/api/v1/videos/gallery')
            .then((videos) => {
                dispatch(setVideoGallery(videos));

                const bannerVideo = getState().createBanner.bannerVideo;
                const videoUploadId = bannerVideo?.videoUploadId;

                if (videoUploadId && videos.some((video) => video.videoUploadId === videoUploadId)) {
                    dispatch(setSelectedVideoUploadId(videoUploadId));
                }
            })
            .catch(() => {
                dispatch([setVideoGallery([]), resetSelectedVideo(null)]);
            });
    };
};
